export type DemoRole = "intern" | "technical-ii" | "department-lead";

export type RoleDefinition = {
  id: DemoRole;
  label: string;
  description: string;
  canManageIncidents: boolean;
  canEditTechnicalRecords: boolean;
  canApproveSensitiveChanges: boolean;
};

export const roles: RoleDefinition[] = [
  {
    id: "intern",
    label: "IT Intern",
    description: "Guided field work, verification, and approved record access.",
    canManageIncidents: false,
    canEditTechnicalRecords: false,
    canApproveSensitiveChanges: false,
  },
  {
    id: "technical-ii",
    label: "Technical II",
    description: "Hands-on operational ownership, diagnostics, assignments, and maintenance.",
    canManageIncidents: true,
    canEditTechnicalRecords: true,
    canApproveSensitiveChanges: false,
  },
  {
    id: "department-lead",
    label: "Department Lead",
    description: "Campus oversight, risk, approvals, vendor performance, and reporting.",
    canManageIncidents: true,
    canEditTechnicalRecords: false,
    canApproveSensitiveChanges: true,
  },
];
